<script>
    import { client, gql } from "../GraphQL.svelte";

    import Login from "./Login.svelte";
    import Overlay from "../components/Overlay.svelte";
    import Dialog from "../components/Dialog.svelte";
    import Background from "../components/Background.svelte";
    import Button from "../components/form/Button.svelte";
    import TextField from "../components/form/TextField.svelte";
    import Notification from "../components/Notification.svelte";

    export let token = window.location.search.split("=")[1];

    let username;
    let newPassword;

    let request;
    let successMsg = "";
    let errMsg = "";

    // TODO: remove token from GET parameter
    //window.history.replaceState("", "", "/reset-password");

    $: valid = username && newPassword && newPassword.length >= 5;

    function handle() {
        request = client.mutate({
            mutation: gql`
                mutation($newPassword: SetNewPasswordInput!) {
                    setNewPassword(newPassword: $newPassword)
                }
            `,
            variables: { newPassword: {
                username, newPassword, resetToken: token
            }}
        })

        .then(res => {
            if (res.data.setNewPassword == true) {
                successMsg = "Password successfully reset";
                request = null;
                window.location.replace("/")
            }
            else {
                errMsg = `Could not reset password. Make sure the reset link is under 10 minutes old and that the given email address is correct.`;
            }
        })

        // TODO: not authorized (!?)
        .catch(err => {
            //debugger;
            errMsg = `There was an error resetting the password: ${err}`;
            request = null;
        });
    }
</script>

<!--<Background content="url('https://unsplash.com/photos/xfngap_DToE/download?force=true&w=1920')"/>-->

<Overlay background="url('https://unsplash.com/photos/xfngap_DToE/download?force=true&w=1920')">
    <Dialog show={true}>
        <h1>Reset password</h1>
        <TextField type="text" label="email address" bind:value={username}/>
        <TextField type="password" label="new password" bind:value={newPassword}/>
        <input type="hidden" name="token" value={token} />
        <Button fullwidth disabled={!valid} on:click={handle} style="width: 100%;">Set new password</Button>
    </Dialog>

    <a href="/logout" class="logout-link">back to login</a>
</Overlay>

<Notification message={successMsg} type="success" />
<Notification message={errMsg} type="error" />

<style>
    input {
        display: block;
        width: 100%;
        margin-bottom: 10px;
    }

    .logout-link {
        text-align: center;
        color: white;
        margin: auto;
        padding: 10px;
        border-radius: 50px;
        text-transform: lowercase;
        font-size: 13px;
        font-weight: 700;
        display: inline-block;
        margin-top: 10px;
    }
</style>